import React from 'react'

// HACK: `break-words` tailwind class contains only `overflow-wrap` w/o `word-break`
export const messageStyle: React.CSSProperties = {
  wordBreak: 'break-word'
}
